import { FC } from 'react';

// components
import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';
import { Badge } from 'dibs-elements/exports/Badge';

// styles
import styles from './PdpSharedAuctionBadge.scss';

export const PdpSharedAuctionBadge: FC = () => (
    <Link href="/auctions/" className={styles.container}>
        <Badge type="pill" size="medium-heavy" letterCase="capitalize" interactive>
            <FormattedMessage id="PdpSharedAuctionBadge" defaultMessage="Auction" />
        </Badge>
    </Link>
);
